import React from 'react';
import { useHistory } from 'react-router-dom';
import { Empty } from '@signicat/designi/components/containers';
import { t } from "../../helpers/i18n";
var Sent = function Sent() {
  var history = useHistory();
  var handleNextClick = function handleNextClick() {
    history.push('/signature');
  };
  return /*#__PURE__*/React.createElement(Empty, {
    emoji: "\uD83D\uDCEC",
    heading: t('signorder_create_sending_heading'),
    message: t('signorder_create_sending_message'),
    action: t('signorder_create_sending_action'),
    handleActionClick: handleNextClick
  });
};
export default Sent;